export default __webpack_public_path__ + "static/media/106.cb859ff5.jpeg";